import { useUBL } from '@common/log-manager';

export const usePromotionUBL = () => {
  const sendUbl = useUBL();

  const impressionPromotionBannerUBL = (
    object_id: string,
    catalog_product_id: string,
    browsing_type: string,
    server_log: any,
  ) => {
    sendUbl({
      category: 'impression',
      navigation: 'product_detail',
      object_section: 'promotion_final_price',
      object_type: 'price',
      object_id,
      data: {
        catalog_product_id,
        browsing_type,
        server_log,
      },
    });
  };

  const clickPromotionBannerUBL = (catalog_product_id: string, browsing_type: string) => {
    sendUbl({
      category: 'click',
      navigation: 'product_detail',
      object_section: 'promotion_final_price',
      object_type: 'button',
      object_id: 'promotion_entry_banner',
      data: { catalog_product_id, browsing_type, server_log: { catalog_product_id, status: 'available' } },
    });
  };

  const impressionPromotionCouponUBL = (
    object_id: string,
    catalog_product_id: string,
    browsing_type: string,
    is_available: boolean,
  ) => {
    sendUbl({
      category: 'impression',
      navigation: 'product_detail',
      object_section: 'promotion_final_price',
      object_type: 'price',
      object_id,
      data: {
        catalog_product_id,
        browsing_type,
        server_log: {
          catalog_product_id,
          status: is_available ? 'available' : 'unavailable',
        },
      },
    });
  };

  const clickPromotionCouponUBL = (catalog_product_id: string, browsing_type: string, is_available: boolean) => {
    sendUbl({
      category: 'click',
      navigation: 'product_detail',
      object_section: 'promotion_final_price',
      object_type: 'button',
      object_id: 'seller_coupon',
      data: {
        catalog_product_id,
        browsing_type,
        server_log: {
          catalog_product_id,
          status: is_available ? 'available' : 'unavailable',
        },
      },
    });
  };

  return {
    impressionPromotionBannerUBL,
    clickPromotionBannerUBL,
    impressionPromotionCouponUBL,
    clickPromotionCouponUBL,
  };
};
